"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionDetails = exports.AccordionSummary = exports.AccordionActions = exports.Accordion = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var core_1 = require("@material-ui/core/");
exports.Accordion = react_1.forwardRef(function Accordion(props, ref) {
    return jsx_runtime_1.jsx(core_1.Accordion, __assign({}, props, { ref: ref }), void 0);
});
exports.AccordionActions = react_1.forwardRef(function AccordionActions(props, ref) {
    return jsx_runtime_1.jsx(core_1.AccordionActions, __assign({}, props, { ref: ref }), void 0);
});
exports.AccordionSummary = react_1.forwardRef(function AccordionSummary(props, ref) {
    return jsx_runtime_1.jsx(core_1.AccordionSummary, __assign({}, props, { ref: ref }), void 0);
});
exports.AccordionDetails = react_1.forwardRef(function AccordionDetails(props, ref) {
    return jsx_runtime_1.jsx(core_1.AccordionDetails, __assign({}, props, { ref: ref }), void 0);
});
//# sourceMappingURL=Accordion.js.map